import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = (_, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isLoggedIn) return true;

  if (state.url && state.url !== '/') {
    sessionStorage.setItem('returnUrl', state.url);
  }
  router.navigate(['/login']);
  return false;
};
